import { combineReducers } from 'redux'
import reduceReducers from 'reduce-reducers'

import project, { initialState as projectInitialState } from './project'
import editor from './editor'
import theme from './theme'

const rootReducer = combineReducers({
  project: reduceReducers(project, editor, theme, projectInitialState)
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js